import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { instance } from "Actions/AxiosInstance";
import addPlusIcon from "Assets/newicons/action/add-round/glyph/add-round-filled-blue-16px.svg";
import duplicate from "Assets/newicons/action/copy/outline/copy-outline-16-px.svg";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import DynamicForm from "Component/DynamicForm";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { ErrorMessages } from "Constants";
import React, { Component } from "react";
import Select from "react-select";
import uniqBy from "lodash/uniqBy";
import moment from "moment";
import { divide } from "lodash";
import InputValues from "Component/InputValues";
import { isSpaceInString } from "Utils";


const POSTDATA = {
  extratimepolicyid: null,
  extratimepolicyname: null,
  description: null,
  isetapprovalrequired: false,
  benefittypeid: 1,
  ispastdateallowed: false,
  isseparatebalance: false,
  ispayableapproverequired: false,
  iscompoffapproverequired: false,
  parentid: null,
  isincludebreak: false,
  extratime: [],
};

const POSTDATA_EXTRATIME_OVERTIMECONFIG = {
  fixedamount: null,
  formula: null,
  starthour: "00:00:00",
  startminute: "00:00:00",
  endhour: "00:00:00",
  endminute: "00:00:00",
  formulaarray: [],
};

const POSTDATA_EXTRATIME = {
  extratimeid: null,
  extratimepolicyid: null,
  isworkingbenefit: true,
  buffertime: "00:00:00",
  isconsiderbuffertime: true,
  requiredhour: "00:00:00",
  maxearninghour: "00:00:00",
  isaccumulation: false,
  isonoptionalholiday: false,
  maxearningcompoff: 0,
  creditcompoff: 0,
  accumulationmonths: 0,
  isonweekoff: false,
  isonholiday: false,
  isperhour: false,
  extratimetypeid: null,
  overtimeconfig: [],
};

const CHAR_TYPES = {
  sign: 1,
  basic: 2,
  number: 3,
  condition: 4,
};

let COUNTER = -1000;

const symbols = [
  { displayvalue: "_plussign", displayname: "+", type: CHAR_TYPES.sign },
  { displayvalue: "_minussign", displayname: "-", type: CHAR_TYPES.sign },
  { displayvalue: "_multiplysign", displayname: "*", type: CHAR_TYPES.sign },
  { displayvalue: "_dividesign", displayname: "/", type: CHAR_TYPES.sign },
  {
    displayvalue: "_startbracketsign",
    displayname: "(",
    type: CHAR_TYPES.sign,
  },
  { displayvalue: "_endbracketsign", displayname: ")", type: CHAR_TYPES.sign },
  { displayvalue: "_percentagesign", displayname: "%", type: CHAR_TYPES.sign },
];

const conditionaloption = [
  {
    displayname: "if",
    displayvalue: -1000,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "else",
    displayvalue: -1002,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "then",
    displayvalue: -1003,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "=",
    displayvalue: -1004,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "!=",
    displayvalue: -1005,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: ">",
    displayvalue: -1006,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "<",
    displayvalue: -1007,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: ">=",
    displayvalue: -1008,
    type: CHAR_TYPES.condition,
  },
  {
    displayname: "<=",
    displayvalue: -1009,
    type: CHAR_TYPES.condition,
  },
];

function FormulaEditor(props) {
  const {
    index,
    opt,
    formulaarray,
    onSelectChange,
    onInputChange,
    intExtraTimeTypeId,
    intIndex,
  } = props;

  return (
    <div className="margin-bottom-16 width60">
      <Select
        components={{
          MultiValueRemove: () => "",
          DropdownIndicator: () => "",
          IndicatorSeparator: () => "",
        }}
        getOptionLabel={(option) => option.displayname}
        getOptionValue={(option) => option.displayvalue}
        isMulti
        options={opt}
        isClearable={true}
        onChange={(value) =>
          onSelectChange(value, intExtraTimeTypeId, intIndex)
        }
        placeholder="Type something and press enter..."
        value={formulaarray}
        onInputChange={(val, action) =>
          onInputChange(val, index, action, intExtraTimeTypeId, intIndex)
        }
      />
    </div>
  );
}

export default class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formulaarray: [],
      hour: null,
      minutes: null,
      duplicateCount: null,
      postData: (this.props.postData && { ...this.props.postData }) || {
        ...POSTDATA,
      },

      DialogOpen: false,
      isformula: false,

      salarycomponent: this.props.salarycomponent,
      options: [
        ...symbols,
        ...conditionaloption,

        {
          displayname: "PACKAGE",
          displayvalue: "1",
          issystem: true,
          ovalue: 1,
          type: 2,
        },
        // {
        //   displayname: "GROSSSALARY",
        //   displayvalue: "2",
        //   issystem: true,
        //   ovalue: 2,
        //   type: 2,
        // },
        // {
        //   displayname: "WORKINGDAY",
        //   displayvalue: "3",
        //   issystem: true,
        //   ovalue: 3,
        //   type: 2,
        // },
        // {
        //   displayname: "MONTHINADAY",
        //   displayvalue: "4",
        //   issystem: true,
        //   ovalue: 4,
        //   type: 2,
        // },
        // {
        //   displayname: "NETSALARY",
        //   displayvalue: "5",
        //   issystem: true,
        //   ovalue: 5,
        //   type: 2,
        // },
      ],
      overtimeworkingdaysoptions: [
        { displayvalue: "1", displayname: "Yes" },
        { displayvalue: "2", displayname: "No" },
      ],
      overtimeworkingdaysid: 1,
      overtimenonworkingdaysoptions: [
        { displayvalue: "1", displayname: "Yes" },
        { displayvalue: "2", displayname: "No" },
      ],
      overtimenonworkingdaysid: 1,
      workhoursoptions: [
        //{ displayvalue: "1", displayname: "Include break hours" },
        { displayvalue: "2", displayname: "Exclude break hours" },
      ],
      workhoursid: 1,
      approvaloptions: [
        {
          displayvalue: "1",
          displayname: "Yes, only for current & future dates",
        },
        {
          displayvalue: "2",
          displayname: "Yes, for past, current & future dates",
        },
        { displayvalue: "3", displayname: "No, approval is not required" },
      ],
      approvalid: 2,
    };

    this.updatePostData = this.updatePostData.bind(this);
    this.duplicateBifuraction = this.duplicateBifuraction.bind(this);
    this.addMoreBifuraction = this.addMoreBifuraction.bind(this);
    this.updateExtraTimeBufferTime = this.updateExtraTimeBufferTime.bind(this);

    this.addExtraTime = this.addExtraTime.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const { options } = this.state;
    const obj = {
      isextrapayment: false,
      isextradeduction: false,
      govstatutorytypeids: [100],
    };
    instance.post("payroll/getallsalarycomponent", obj).then((res) => {
      const component =
        res.data.result.map((x) => ({
          displayvalue: x.displayvalue,
          displayname: x.displayname,
          ovalue: x.displayvalue,
          type: CHAR_TYPES.basic,
          isbalancing: x.isbalancing,
          isgrosscomponent: x.isgrosscomponent,
        })) || [];
      this.setState({
        options: options.concat(component),
        salarycomponent: component,
      });
    });
  }

  onInputChange(inputval, index, action, intExtraTimeTypeId, intIndex) {
    let { options, postData } = { ...this.state };

    const objPostDataExtraTime = {
      ...postData.extratime.find(
        (ext) => ext.extratimetypeid == intExtraTimeTypeId,
      ),
    };
    const objConfig = [...objPostDataExtraTime.overtimeconfig][intIndex];

    if (action && action.action == "input-blur") {
      let backupoption = uniqBy(options, "displayname");
      backupoption = [
        ...backupoption.filter((option) => option.type != CHAR_TYPES.number),
      ];
      options = [...backupoption];
      if (objConfig.formulaarray && objConfig.formulaarray.length > 0) {
        const lastvalue =
          objConfig.formulaarray[objConfig.formulaarray.length - 1];
        let isvalid = true;
        const closecount =
          objConfig.formulaarray.filter((val1) => val1.displayname == ")") ||
          [];
        const opencount =
          objConfig.formulaarray.filter((val1) => val1.displayname == "(") ||
          [];
        isvalid =
          lastvalue.type == CHAR_TYPES.basic ||
          lastvalue.type == CHAR_TYPES.number ||
          lastvalue.displayname == ")";
        if (isvalid) {
          isvalid = closecount.length == opencount.length ? true : false;
          if (!isvalid) {
            this.props.enqueueSnackbar("Please check paranthesis", {
              variant: "error",
            });
          }
        } else {
          isvalid = false;
        }
        options = isvalid
          ? [
              ...options,
              ...objConfig.formulaarray.map((option) => ({
                ...option,
                isadded: true,
                displayvalue: `${option.displayvalue}1`,
              })),
            ]
          : [
              ...options,
              ...objConfig.formulaarray
                .filter((option, i) => i < objConfig.formulaarray.length - 1)
                .map((option) => ({
                  ...option,
                  isadded: true,
                  displayvalue: `${option.displayvalue}1`,
                })),
            ];
        objConfig.formulaarray = isvalid
          ? [
              ...objConfig.formulaarray.map((option) => ({
                ...option,
                isadded: true,
                displayvalue: `${option.displayvalue}1`,
              })),
            ]
          : [
              ...objConfig.formulaarray
                .filter((option, i) => i < objConfig.formulaarray.length - 1)
                .map((option) => ({
                  ...option,
                  isadded: true,
                  displayvalue: `${option.displayvalue}1`,
                })),
            ];
        if (isvalid) {
          const names = objConfig.formulaarray.map((val1) => val1.displayname);
          objConfig.formula = names.join("");
          const allComponent = options.filter(
            (opt) => opt.issystem || opt.displayname == "Basic Pay",
          );
          allComponent.forEach((option) => {
            console.log("option: ", option);
            if (objConfig.formula.includes(option.displayname)) {
              objConfig.formula = objConfig.formula
                .split(option.displayname)
                .join(`${option.issystem ? "S" : "C"}_${option.displayvalue}`);
            }
          });
        }
        objConfig.originalformula = objConfig.formulaarray
          .map((val1) => ` ${val1.displayname} `)
          .join("");

        objConfig.isvalid = isvalid;
        objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

        postData.extratime.forEach((ext, extIndex) => {
          if (ext.extratimetypeid == intExtraTimeTypeId) {
            postData.extratime[extIndex] = { ...objPostDataExtraTime };
          }
        });

        this.setState({ postData });
      } else {
        objConfig.formula = null;
        objConfig.originalformula = null;
        objConfig.formulaarray = [];
        objConfig.isvalid = false;

        objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

        postData.extratime.forEach((ext, extIndex) => {
          if (ext.extratimetypeid == intExtraTimeTypeId) {
            postData.extratime[extIndex] = { ...objPostDataExtraTime };
          }
        });
        this.setState({ postData });
      }

      objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

      postData.extratime.forEach((ext, extIndex) => {
        if (ext.extratimetypeid == intExtraTimeTypeId) {
          postData.extratime[extIndex] = { ...objPostDataExtraTime };
        }
      });
      this.setState({ postData });
      return;
    }
    if (!inputval && !Number.isInteger(parseInt(inputval))) {
      objConfig.originalformula = objConfig.formulaarray
        .map((val1) => ` ${val1.displayname} `)
        .join("");

      objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

      postData.extratime.forEach((ext, extIndex) => {
        if (ext.extratimetypeid == intExtraTimeTypeId) {
          postData.extratime[extIndex] = { ...objPostDataExtraTime };
        }
      });
      this.setState({ postData });
      return;
    }
    if (Number(inputval)) {
      options = options.filter((x) => x.displayvalue != COUNTER);

      objConfig.originalformula = objConfig.formulaarray
        .map((val1) => ` ${val1.displayname} `)
        .join("");

      options.unshift({
        displayvalue: COUNTER,
        displayname: inputval,
        type: CHAR_TYPES.number,
      });

      objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

      postData.extratime.forEach((ext, extIndex) => {
        if (ext.extratimetypeid == intExtraTimeTypeId) {
          postData.extratime[extIndex] = { ...objPostDataExtraTime };
        }
      });

      this.setState({
        options,
        postData,
      });
    }
  }

  onSelectChange(val, intExtraTimeTypeId, intIndex) {
    let { options, postData } = { ...this.state };

    // const objPostDataExtraTime = { ...postData.extratime[intExtraTimeTypeId - 1] };
    // const objConfig = [...objPostDataExtraTime.overtimeconfig][intIndex];

    const objPostDataExtraTime = {
      ...postData.extratime.find(
        (ext) => ext.extratimetypeid == intExtraTimeTypeId,
      ),
    };
    const objConfig = [...objPostDataExtraTime.overtimeconfig][intIndex];

    let backupoption = uniqBy(options, "displayname");
    backupoption = [
      ...backupoption.filter((option) => option.type != CHAR_TYPES.number),
    ];

    COUNTER -= 1;
    options = [...backupoption];
    if (val && val.length > 0) {
      let isvalid = true;
      const lastindex = val.length - 1;
      const lastvalue = val[val.length - 1];
      const samevalue = val[val.length - 1] == val[lastindex - 1];
      const secondlastvalue = val[lastindex - 1];
      const signsWithoutClose = symbols.filter((x) => x.displayname != ")");
      // const signsWithoutOpen = symbols.filter((x) => x.displayname != "(");
      if (val.length == 1) {
        isvalid =
          lastvalue.type == CHAR_TYPES.basic ||
          lastvalue.type == CHAR_TYPES.number ||
          lastvalue.displayname == "(" ||
          lastvalue.displayname == "if";
        if (lastvalue.displayname == "if") {
          val = isvalid
            ? [
                ...val,
                {
                  displayvalue: `_startbracketsign1${lastindex}`,
                  displayname: "(",
                  type: CHAR_TYPES.sign,
                },
              ]
            : val;
        }
      } else if (val.length > 1) {
        if (samevalue) {
          isvalid = false;
        } else if (!samevalue) {
          if (
            lastvalue.type == CHAR_TYPES.basic ||
            lastvalue.type == CHAR_TYPES.number
          ) {
            isvalid =
              secondlastvalue.type == CHAR_TYPES.condition ||
              signsWithoutClose.find((x) => x.type == secondlastvalue.type)
                ? true
                : false;
          } else if (
            lastvalue.type == CHAR_TYPES.sign &&
            lastvalue.displayname != "("
          ) {
            isvalid =
              secondlastvalue.type == CHAR_TYPES.number ||
              secondlastvalue.type == CHAR_TYPES.basic ||
              secondlastvalue.displayname == ")"
                ? true
                : false;
          } else if (
            lastvalue.type == CHAR_TYPES.condition &&
            lastvalue.displayname == "if"
          ) {
            isvalid = signsWithoutClose.find(
              (x) => x.type == secondlastvalue.type,
            )
              ? true
              : false;
            val = isvalid
              ? [
                  ...val,
                  {
                    displayvalue: `_startbracketsign1${lastindex}`,
                    displayname: "(",
                    type: CHAR_TYPES.sign,
                  },
                ]
              : val;
          } else if (
            lastvalue.type == CHAR_TYPES.condition &&
            // lastvalue.displayname == "elseif"
            (lastvalue.displayname == "else" || lastvalue.displayname == "then")
          ) {
            isvalid =
              secondlastvalue.type == CHAR_TYPES.number ||
              secondlastvalue.type == CHAR_TYPES.basic ||
              secondlastvalue.displayname == ")"
                ? true
                : false;
            val = isvalid
              ? [
                  ...val,
                  {
                    displayvalue: `_startbracketsign1${lastindex}`,
                    displayname: "(",
                    type: CHAR_TYPES.sign,
                  },
                ]
              : val;
          } else if (
            lastvalue.type == CHAR_TYPES.condition &&
            // lastvalue.displayname != "elseif"
            (lastvalue.displayname != "else" ||
              lastvalue.displayname != "then" ||
              lastvalue.displayname != "if")
          ) {
            isvalid =
              secondlastvalue.type == CHAR_TYPES.number ||
              secondlastvalue.type == CHAR_TYPES.basic ||
              secondlastvalue.displayname == ")"
                ? true
                : false;
          }
        }
      }

      options = isvalid
        ? [
            ...options,
            ...val.map((option) => ({
              ...option,
              isadded: true,
              displayvalue: `${option.displayvalue}1`,
            })),
          ]
        : [
            ...options,
            ...val
              .filter((option, i) => i < val.length - 1)
              .map((option) => ({
                ...option,
                isadded: true,
                displayvalue: `${option.displayvalue}1`,
              })),
          ];
      val = isvalid
        ? [
            ...val.map((option) => ({
              ...option,
              isadded: true,
              displayvalue: `${option.displayvalue}1`,
            })),
          ]
        : [
            ...val
              .filter((option, i) => i < val.length - 1)
              .map((option) => ({
                ...option,
                isadded: true,
                displayvalue: `${option.displayvalue}1`,
              })),
          ];
      objConfig.formulaarray = val;
      objConfig.isvalid = isvalid;
      objConfig.formula = val;
      objConfig.originalformula = val.map((x) => ` ${x.displayname} `).join("");

      objPostDataExtraTime.overtimeconfig[intIndex] = { ...objConfig };

      postData.extratime.forEach((ext, extIndex) => {
        if (ext.extratimetypeid == intExtraTimeTypeId) {
          postData.extratime[extIndex] = { ...objPostDataExtraTime };
        }
      });
      this.setState({ options, val, postData });
    } else {
      objConfig.formulaarray = [];
      objConfig.formula = null;
      objConfig.originalformula = null;
      objConfig.isvalid = false;
      this.setState({ options, val: [], postData });
    }
  }

  updatePostData(key, value) {
    const postData = { ...this.state.postData };
    if (key == "approvaltype") {
      postData.isetapprovalrequired = value == 3 ? false : true;
      postData.ispastdateallowed = value == 2 ? true : false;
    } else {
      postData[key] = value;
    }

    this.setState({ postData });
  }

  addExtraTime(intExtraTimeTypeId) {
    const postDataExtraTime = [...this.state.postData.extratime];
    postDataExtraTime.push({
      ...POSTDATA_EXTRATIME,
      extratimetypeid: intExtraTimeTypeId,
      isonweekoff: intExtraTimeTypeId == 1 ? false : true,
      isonholiday: intExtraTimeTypeId == 1 ? false : true,
      isonoptionalholiday: intExtraTimeTypeId == 1 ? false : true,
    });

    const postExtraTimeOverTimeConfig = {
      ...POSTDATA_EXTRATIME_OVERTIMECONFIG,
    };

    postDataExtraTime.forEach((ext) => {
      if (ext.extratimetypeid == intExtraTimeTypeId) {
        ext.overtimeconfig[0] = { ...postExtraTimeOverTimeConfig };
      }
    });

    this.setState({
      postData: { ...this.state.postData, extratime: [...postDataExtraTime] },
    });
  }

  removeExtraTime(intExtraTimeTypeId) {
    const postData = { ...this.state.postData };
    intExtraTimeTypeId == 1
      ? postData.extratime.shift()
      : postData.extratime.pop();
    this.setState({ postData });
  }

  updateExtraTimeBufferTime(key, value, intExtraTimeTypeId) {
    const arrExtraTime = [...this.state.postData.extratime];
    const arrOverTimeConfig = [
      ...arrExtraTime.find(
        (ext) => ext && ext.extratimetypeid == intExtraTimeTypeId,
      ).overtimeconfig,
    ];
    let requiredhour = arrExtraTime
      .find((ext) => ext && ext.extratimetypeid == intExtraTimeTypeId)
      .requiredhour.split(":");

    if (key == "bufferhours") {
      requiredhour = moment(
        `${parseInt(value)}:${requiredhour[1]}:00`,
        "HH:mm:ss",
      ).format("HH:mm:ss");
    } else {
      requiredhour = moment(
        `${requiredhour[0]}:${parseInt(value)}:00`,
        "HH:mm:ss",
      ).format("HH:mm:ss");
    }

    arrOverTimeConfig[0] = {
      ...arrOverTimeConfig[0],
      starthour: moment(requiredhour, "HH:mm:ss").format("HH:00:00"),
      startminute: moment(requiredhour, "HH:mm:ss").format("00:mm:00"),
    };

    arrExtraTime.forEach((ext, index) => {
      if (ext.extratimetypeid == intExtraTimeTypeId) {
        arrExtraTime[index] = {
          ...ext,
          requiredhour,
          overtimeconfig: arrOverTimeConfig,
        };
      }
    });

    this.setState({
      postData: { ...this.state.postData, extratime: [...arrExtraTime] },
    });
  }

  updateOverTimeInput(key, value, intExtraTimeTypeId, intIndex, arrOverTimeSlot) {

    const intMinValidValue = this.getMinValidOverTimeValue(key, intIndex, arrOverTimeSlot)

    if(value < intMinValidValue) {
      this.props.enqueueSnackbar(
        `${key == 'starthour' 
            ? 'Start hour'
            : key == 'startminute'
              ? 'Start minute'
              : key == 'endhour'
                ? 'End hour'
                : key == 'endminute'
                  ? 'End minute'
                  : ''
          } 
          must not be less than ${intMinValidValue}
          ${key == 'starthour' || key == 'endhour'
            ? 'hour'
            : key == 'startminute' || key == 'endminute'
              ? 'minute'
              : ''
          }
          `, { variant: "error" });
      return;
    };

    const arrExtraTime = [...this.state.postData.extratime];
    const arrOverTimeConfig = [
      ...arrExtraTime.find(
        (ext) => ext && ext.extratimetypeid == intExtraTimeTypeId,
      ).overtimeconfig,
    ];
    const strTime = moment(arrOverTimeConfig[intIndex][key], "HH:mm:ss");

    switch (key) {
      case "endhour":
        arrOverTimeConfig[intIndex][key] = strTime
          .set("hour", `${value}`)
          .format("HH:00:00");
        break;
      case "endminute":
        arrOverTimeConfig[intIndex][key] = moment(
          arrOverTimeConfig[intIndex].endminute,
          "HH:mm:ss",
        )
          .set("minute", `${value}`)
          .format("00:mm:00");
        break;
      case "starthour":
        arrOverTimeConfig[intIndex][key] = strTime
          .set(`${value}`, "hour")
          .format("HH:00:00");
        break;
      case "startminute":
        arrOverTimeConfig[intIndex][key] = moment(
          arrOverTimeConfig[intIndex].endminute,
          "HH:mm:ss",
        )
          .set("minute", `${value}`)
          .format("00:mm:00");
        break;
      default:
        break;
    }

    arrExtraTime.forEach((ext, index) => {
      if (ext.extratimetypeid == intExtraTimeTypeId) {
        arrExtraTime[index] = { ...ext, overtimeconfig: arrOverTimeConfig };
      }
    });
    this.setState({
      postData: { ...this.state.postData, extratime: [...arrExtraTime] },
    });
  }

  deleteOverTimeSlot(intExtraTimeTypeId) {
    const arrExtraTime = [...this.state.postData.extratime];
    const arrOverTimeConfig = [
      ...arrExtraTime.find(
        (ext) => ext && ext.extratimetypeid == intExtraTimeTypeId,
      ).overtimeconfig,
    ];

    arrOverTimeConfig.pop();

    arrExtraTime.forEach((ext, index) => {
      if (ext.extratimetypeid == intExtraTimeTypeId) {
        arrExtraTime[index] = { ...ext, overtimeconfig: arrOverTimeConfig };
      }
    });

    this.setState({
      postData: { ...this.state.postData, extratime: arrExtraTime },
    });
  }

  getMinValidOverTimeValue(key, index, arrOverTimeConfig) {
    const intCurrStartHour = parseInt(
      arrOverTimeConfig[index].starthour.split(":")[0],
    );
    const intCurrEndHour = parseInt(
      arrOverTimeConfig[index].endhour.split(":")[0],
    );
    const intCurrStartMinute = parseInt(
      arrOverTimeConfig[index].startminute.split(":")[1],
    );

    const intPvsEndHour = index
      ? parseInt(arrOverTimeConfig[index - 1].endhour.split(":")[0])
      : null;
    const intPvsEndMinute = index
      ? parseInt(arrOverTimeConfig[index - 1].endminute.split(":")[1])
      : null;

    switch (key) {
      case "endhour":
        return intCurrStartHour;
      case "endminute":
        return intCurrStartHour == intCurrEndHour ? intCurrStartMinute : 0;
      case "starthour":
        return intPvsEndHour;
      case "startminute":
        return intCurrStartHour == intPvsEndHour ? intPvsEndMinute : 0;
      default:
        break;
    }
  }

  isOverTimeSlotDisable(key, index, arrOverTimeConfig) {
    const intCurrStartHour = parseInt(
      arrOverTimeConfig[index].starthour.split(":")[0],
    );

    const intCurrStartMinute = parseInt(
      arrOverTimeConfig[index].startminute.split(":")[1],
    );

    const intCurrEndHour = parseInt(
      arrOverTimeConfig[index].endhour.split(":")[0],
    );

    const intPvsEndHour = index
      ? parseInt(arrOverTimeConfig[index - 1].endhour.split(":")[0])
      : null;

    switch (key) {
      case "endhour":
        return intCurrStartHour || intCurrStartMinute ? false : true;
      case "endminute":
        return intCurrEndHour || intCurrStartMinute ? false : true;
      case "starthour":
        return index != 0 && intPvsEndHour ? false : true;
      case "startminute":
        return index != 0 && intCurrStartHour ? false : true;
      default:
        break;
    }
  }

  addMoreBifuraction(intExtraTimeTypeId, arrOverTimeConfig) {
    const strPvsEndHour =
      arrOverTimeConfig[arrOverTimeConfig.length - 1].endhour || "00:00:00";
    const strPvsEndMinute =
      arrOverTimeConfig[arrOverTimeConfig.length - 1].endminute || "00:00:00";

    const strPvsStartHour =
      arrOverTimeConfig[arrOverTimeConfig.length - 1].starthour || "00:00:00";
    const strPvsStartMinute =
      arrOverTimeConfig[arrOverTimeConfig.length - 1].startminute || "00:00:00";

    const intPvsEndHour = parseInt(strPvsEndHour.split(":")[0]);
    const intPvsEndMinute = parseInt(strPvsEndMinute.split(":")[1]);
    const intPvsStartHour = parseInt(strPvsStartHour.split(":")[0]);
    const intPvsStartMinute = parseInt(strPvsStartMinute.split(":")[1]);

    if (
      intPvsEndHour < intPvsStartHour ||
      (intPvsEndHour == intPvsStartHour && intPvsEndMinute < intPvsStartMinute)
    ) {
      this.props.enqueueSnackbar("Please add correct end time", {
        variant: "error",
      });
      return false;
    }

    let strCurrStartHour = `00:00:00`;
    let strCurrStartMinute = `00:00:00`;

    if (intPvsEndMinute == 59) {
      strCurrStartHour = moment(`${intPvsEndHour}:00:00`, "HH:mm:ss")
        .add("hours", 1)
        .format("HH:00:00");
      strCurrStartMinute = moment(`00:00:00`, "HH:mm:ss").format("00:mm:00");
    } else {
      strCurrStartHour = moment(`${intPvsEndHour}:00:00`, "HH:mm:ss").format(
        "HH:00:00",
      );
      strCurrStartMinute = moment(`00:${intPvsEndMinute}:00`, "HH:mm:ss")
        .add("minutes", 1)
        .format("00:mm:00");
    }

    const postData = { ...this.state.postData };

    arrOverTimeConfig.push({
      ...POSTDATA_EXTRATIME_OVERTIMECONFIG,
      starthour: moment(strCurrStartHour, "HH:mm:ss").format("HH:00:00"),
      startminute: moment(strCurrStartMinute, "HH:mm:ss").format("00:mm:00"),
    });

    postData.extratime.forEach((ext) => {
      if (ext.extratimetypeid == intExtraTimeTypeId) {
        ext.overtimeconfig = [...arrOverTimeConfig];
      }
    });

    this.setState({ postData });
  }

  duplicateBifuraction() {
    let { duplicatebifuractionid, duplicateCount, postData } = {
      ...this.state,
    };

    let isFirstItr = true;

    let arrOverTimeConfig = [
      ...postData.extratime.find(
        (ext) => ext.extratimetypeid == duplicatebifuractionid,
      ).overtimeconfig,
    ];
    let objLastOverTimeConfig = arrOverTimeConfig[arrOverTimeConfig.length - 1];

    if (!objLastOverTimeConfig.formula && !objLastOverTimeConfig.fixedamount) {
      this.props.enqueueSnackbar("Please add end formula/fixedamount", {
        variant: "error",
      });
      return false;
    }

    while (duplicateCount--) {
      if (isFirstItr) isFirstItr = false;
      else {
        arrOverTimeConfig = [
          ...postData.extratime.find(
            (ext) => ext.extratimetypeid == duplicatebifuractionid,
          ).overtimeconfig,
        ];
        objLastOverTimeConfig = arrOverTimeConfig[arrOverTimeConfig.length - 1];
      }

      const strPvsEndMinute = moment(
        objLastOverTimeConfig.endminute,
        "HH:mm:ss",
      );

      const strPvsEndHour = moment(objLastOverTimeConfig.endhour, "HH:mm:ss");

      const strPvsStartMinute = moment(
        objLastOverTimeConfig.startminute,
        "HH:mm:ss",
      );

      const strPvsStartHour = moment(
        objLastOverTimeConfig.starthour,
        "HH:mm:ss",
      );
      let intMinuteGap = strPvsEndMinute.diff(strPvsStartMinute, "minutes");
      let intHourGap = strPvsEndHour.diff(strPvsStartHour, "hours");

      if (intHourGap < 0) {
        this.props.enqueueSnackbar("Please enter correct end time", {
          variant: "error",
        });
        return false;
      } else if (intHourGap == 0 && intMinuteGap < 0) {
        this.props.enqueueSnackbar("Please enter correct end time", {
          variant: "error",
        });
        return false;
      }

      let strCurrStartHour;
      let strCurrStartMinute;
      if (moment(objLastOverTimeConfig.endminute, "HH:mm:ss").minutes() == 59) {
        strCurrStartHour = moment(objLastOverTimeConfig.endhour, "HH:mm:ss")
          .add("hours", 1)
          .format("HH:00:00");
        strCurrStartMinute = moment("00:00:00", "HH:mm:ss").format("00:mm:00");
      } else {
        strCurrStartHour = moment(
          objLastOverTimeConfig.endhour,
          "HH:mm:ss",
        ).format("HH:00:00");
        strCurrStartMinute = moment(objLastOverTimeConfig.endminute, "HH:mm:ss")
          .add("minutes", 1)
          .format("00:mm:00");
      }

      if (
        moment(strCurrStartMinute, "HH:mm:ss").minutes() + intMinuteGap >
        60
      ) {
        intHourGap += 1;
        intMinuteGap =
          60 -
          (moment(strCurrStartMinute, "HH:mm:ss").minutes() + intMinuteGap);
      }

      const strCurrEndHour = moment(strCurrStartHour, "HH:mm:ss")
        .add("hours", intHourGap)
        .format("HH:00:00");
      const strCurrEndMinute = moment(strCurrStartMinute, "HH:mm:ss")
        .add("minutes", intMinuteGap)
        .format("00:mm:00");

      arrOverTimeConfig.push({
        ...POSTDATA_EXTRATIME_OVERTIMECONFIG,
        starthour: strCurrStartHour,
        startminute: strCurrStartMinute,
        endhour: strCurrEndHour,
        endminute: strCurrEndMinute,
        formula: objLastOverTimeConfig.formula,
        originalformula: objLastOverTimeConfig.originalformula,
        formulaarray: objLastOverTimeConfig.formulaarray,
        valid: objLastOverTimeConfig.valid,
      });

      postData.extratime.forEach((ext) => {
        if (ext.extratimetypeid == duplicatebifuractionid) {
          ext.overtimeconfig = [...arrOverTimeConfig];
        }
      });
    }

    this.setState({ postData, duplicateCount: 0, DialogOpen: false });
  }

  onCancel = () => {
    this.props.enqueueSnackbar(` Are you sure, you would lost your progress?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.setState(
              {
                postData: { ...POSTDATA },
              },
              () => {
                this.props.history.push(`${this.props.match.path}`);
                this.props.closeSnackbar();
              },
            );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  isValidRequest(objReq) {

    if (objReq.extratimepolicyname && !isSpaceInString(objReq.extratimepolicyname)) {
      objReq.extratimepolicyname = objReq.extratimepolicyname.trim();
    }


    if (!objReq.extratimepolicyname || objReq.extratimepolicyname == "") {
      this.props.enqueueSnackbar("Please give policy a name", {
        variant: "error",
      });
      return false;
    }

    if (!objReq.extratime || objReq.extratime.length == 0) {
      this.props.enqueueSnackbar(
        "Please add atleast one applicable condition",
        { variant: "error" },
      );
      return false;
    }

    if (objReq.extratime.some((ext) => ext.requiredhour == "00:00:00")) {
      this.props.enqueueSnackbar("Please add minimum hours", {
        variant: "error",
      });
      return false;
    }

    if (
      objReq.extratime.some((ext) =>
        ext.overtimeconfig.some(
          (ot) =>
            moment(ot.endhour, "HH:mm:ss").hours() <
              moment(ot.starthour, "HH:mm:ss").hours() ||
            (moment(ot.endhour, "HH:mm:ss").hours() ==
              moment(ot.starthour, "HH:mm:ss").hours() &&
              moment(ot.endminute, "HH:mm:ss").minutes() <
                moment(ot.startminute, "HH:mm:ss").minutes()) ||
            !(ot.formula || ot.fixedamount),
        ),
      )
    ) {
      this.props.enqueueSnackbar(
        "Please check if you've entered valid start/end hour or payment calculations.",
        { variant: "error" },
      );
      return false;
    }

    return true;
  }

  onSave() {
    const { postData } = { ...this.state };

    postData.extratime.forEach((objET) => {
      objET &&
        objET.overtimeconfig.forEach((objOT) => {
          if (/^\+?(0|[1-9]\d*)$/.test(objOT.formula)) {
            objOT.fixedamount = objOT.formula;
            objOT.formula = null;
          }
          const starthour = moment(objOT.starthour, "HH:mm:ss");
          const startminute = moment(objOT.startminute, "HH:mm:ss");
          objOT.starttime = starthour
            .add("minutes", startminute.minutes())
            .format("HH:mm:ss");

          const endhour = moment(objOT.endhour, "HH:mm:ss");
          const endminute = moment(objOT.endminute, "HH:mm:ss");
          objOT.endtime = endhour
            .add("minutes", endminute.minutes())
            .format("HH:mm:ss");

          delete objOT.isvalid;
          delete objOT.originalformula;
        });
    });

    if (!this.isValidRequest(postData)) return;

    instance
      .post("attendance/extratimepaypolicy", postData)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.setState(
          {
            postData: { ...POSTDATA },
          },
          () => {
            this.props.history.push(`${this.props.match.path}`);
            this.props.getAllExtraTimePayPolicy();
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response.data.error.message, {
          variant: "error",
        });
      });
  }

  renderOverTimeInput(objExtraTime) {
    const { options } = this.state;

    const opt = [];
    opt.push({
      label: "Number",
      options: uniqBy(
        options.filter((x) => x.type == CHAR_TYPES.number),
        "displayname",
      ),
    });

    opt.push({
      label: "System variables",
      options: uniqBy(
        options.filter((x) => x.issystem),
        "displayname",
      ),
    });

    opt.push({
      label: "Components",
      options: uniqBy(
        options.filter(
          (x) => !x.issystem && !x.iscustom && x.type == CHAR_TYPES.basic,
        ),
        "displayname",
      ),
    });

    opt.push({
      label: "Conditions",
      options: uniqBy(
        options.filter(
          (x) =>
            x.type == CHAR_TYPES.condition &&
            (x.displayname == "if" ||
              // || x.displayname == "elseif"
              x.displayname == "then" ||
              x.displayname == "else"),
        ),
        "displayname",
      ),
    });

    opt.push({
      label: "Arithmatic operators",
      options: uniqBy(
        [...options.filter((x) => x.type == CHAR_TYPES.sign)],
        "displayname",
      ),
    });

    opt.push({
      label: "Relational Operators",
      options: uniqBy(
        [
          ...options.filter(
            (x) =>
              x.type == CHAR_TYPES.condition &&
              (x.displayname == "=" ||
                x.displayname == "!=" ||
                x.displayname == ">" ||
                x.displayname == "<" ||
                x.displayname == "<=" ||
                x.displayname == ">="),
          ),
        ],
        "displayname",
      ),
    });

    return (
      <div>
        <Paper className="rounded-rectangle-paper padding16 overflow-y-auto">
          <p className="normal-dark margin-bottom-16">
            Minimum {objExtraTime.extratimetypeid == 1 ? "overtime" : "working"}{" "}
            hours required to be eligible for payment
          </p>
          <div
            className="display-flex margin-bottom-24"
            style={{ alignItems: "center" }}
          >
            <div style={{ width: 100, marginBottom: -16 }}>
              <InputValues
                max="23"
                min="0"
                onChange={(e) =>
                  this.updateExtraTimeBufferTime(
                    "bufferhours",
                    e.target.value,
                    objExtraTime.extratimetypeid,
                  )
                }
                value={objExtraTime.requiredhour.split(":")[0] || null}
              />
            </div>
            <span className="small-dark margin-left-8">hours</span>
            <div style={{ width: 100, marginBottom: -16, marginLeft: 16 }}>
              <InputValues
                max="59"
                min="15"
                onChange={(e) =>
                  this.updateExtraTimeBufferTime(
                    "bufferminutes",
                    e.target.value,
                    objExtraTime.extratimetypeid,
                  )
                }
                value={objExtraTime.requiredhour.split(":")[1] || null}
              />
            </div>
            <span className="small-dark margin-left-8">minutes</span>
          </div>

          {objExtraTime.overtimeconfig &&
            objExtraTime.overtimeconfig.map((objConfig, index) => (
              <div>
                <Grid container className="margin-bottom-8">
                  <Grid item sm={12} md={3}>
                    <p className="small-dark-secondary t-bold">
                      Start hour & minute
                    </p>
                  </Grid>
                  <Grid item sm={12} md={3}>
                    <p className="small-dark-secondary t-bold">
                      End hour & minute
                    </p>
                  </Grid>
                  <Grid item sm={12} md={4}>
                    <p className="small-dark-secondary t-bold">
                      Payment calculation
                    </p>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item sm={12} md={3}>
                    <div className="display-flex">
                      <div style={{ width: 100 }}>
                        <InputValues
                            max="23"
                            min={this.getMinValidOverTimeValue(
                              "starthour",
                              index,
                              objExtraTime.overtimeconfig,
                            )}
                            disabled={this.isOverTimeSlotDisable(
                              "starthour",
                              index,
                              objExtraTime.overtimeconfig,
                            )}
                          onChange={(e) =>
                            this.updateOverTimeInput(
                              "starthour",
                              e.target.value,
                              objExtraTime.extratimetypeid,
                              index,
                              objExtraTime.overtimeconfig
                            )
                          }
                          value={objConfig.starthour.split(":")[0]}
                        />
                      </div>
                      <div style={{ width: 100, marginLeft: 16 }}>

                          <InputValues
                            max="59"
                            min={this.getMinValidOverTimeValue(
                              "startminute",
                              index,
                              objExtraTime.overtimeconfig,
                            )}
                            disabled={this.isOverTimeSlotDisable(
                              "startminute",
                              index,
                              objExtraTime.overtimeconfig,
                            )}
                            onChange={(e) =>
                              this.updateOverTimeInput(
                                "startminute",
                                e.target.value,
                                objExtraTime.extratimetypeid,
                                index,
                                objExtraTime.overtimeconfig
                              )
                            }
                            value={objConfig.startminute.split(":")[1]}
                          />
                      </div>
                    </div>
                  </Grid>
                  <Grid item sm={12} md={3}>
                    <div className="display-flex">
                      <div style={{ width: 100 }}>
                        <InputValues
                          max="23"
                          min={this.getMinValidOverTimeValue(
                            "endhour",
                            index,
                            objExtraTime.overtimeconfig,
                          )}                          
                          disabled={this.isOverTimeSlotDisable(
                            "endhour",
                            index,
                            objExtraTime.overtimeconfig,
                          )}
                          onChange={(e) =>
                            this.updateOverTimeInput(
                              "endhour",
                              e.target.value,
                              objExtraTime.extratimetypeid,
                              index,
                              objExtraTime.overtimeconfig
                            )
                          }
                          value={objConfig.endhour.split(":")[0]}
                        />
                      </div>
                      <div style={{ width: 100, marginLeft: 16 }}>
                        <InputValues
                          max="59"
                          min={this.getMinValidOverTimeValue(
                            "endminute",
                            index,
                            objExtraTime.overtimeconfig,
                          )}                          
                          disabled={this.isOverTimeSlotDisable(
                            "endminute",
                            index,
                            objExtraTime.overtimeconfig,
                          )}
                          onChange={(e) =>
                            this.updateOverTimeInput(
                              "endminute",
                              e.target.value,
                              objExtraTime.extratimetypeid,
                              index,
                              objExtraTime.overtimeconfig
                            )
                          }
                          value={objConfig.endminute.split(":")[1]}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <FormulaEditor
                        isformula={this.state.isformula}
                        editableKey={this.props.editableKey}
                        opt={opt}
                        salarycomponent={this.state.salarycomponent}
                        formula={objConfig.formula}
                        formulaarray={objConfig.formulaarray}
                        onSelectChange={this.onSelectChange.bind(this)}
                        intExtraTimeTypeId={objExtraTime.extratimetypeid}
                        intIndex={index}
                        onInputChange={this.onInputChange.bind(this)}
                      />
                      {index != 0 &&
                        index == objExtraTime.overtimeconfig.length - 1 && (
                          <div className="margin-left-16">
                            <img
                              src={deleteIcon}
                              onClick={() =>
                                this.deleteOverTimeSlot(
                                  objExtraTime.extratimetypeid,
                                )
                              }
                            ></img>
                          </div>
                        )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            ))}

          <Button
            variant="contained"
            className="btn btn-secondary-md-blue margin-right-8"
            color="primary"
            onClick={() =>
              this.addMoreBifuraction(
                objExtraTime.extratimetypeid,
                objExtraTime.overtimeconfig,
              )
            }
            startIcon={<img src={addPlusIcon} />}
          >
            Add more bifurcations
          </Button>
          <Button
            variant="contained"
            className="btn btn-secondary-md-blue"
            color="primary"
            onClick={() =>
              this.setState({
                DialogOpen: true,
                duplicatebifuractionid: objExtraTime.extratimetypeid,
              })
            }
            startIcon={<img src={duplicate} />}
          >
            Duplicate above bifurcation
          </Button>
        </Paper>
      </div>
    );
  }

  render() {
    const {
      postData,
      workhoursoptions,
      overtimeworkingdaysoptions,
      approvaloptions,
    } = this.state;

    return (
      <div className="content-outer-wrapper" style={{ marginBottom: 80 }}>
        <p className="large-text-dark margin-bottom-16 t-bold">
          New extratime payment policy
        </p>

        <div className="display-flex" style={{ alignItems: "flex-start" }}>
          <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
          <div className="width60">
            <p className="normal-dark margin-bottom-8 display-flex">
              Extratime payment policy name
            </p>

            <DynamicForm
              fields={textinputconverter({
                value: postData.extratimepolicyname,
                placeholder: "",
                label: "",
              })}
              onChange={(value) => {
                this.updatePostData("extratimepolicyname", value);
              }}
            />
          </div>
        </div>

        <div
          className="display-flex"
          style={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            className="display-flex margin-bottom-16"
            style={{ alignItems: "center" }}
          >
            <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
            <p className="normal-dark">
              Pay when an employee does overtime on a work day
            </p>
          </div>
          <div style={{ width: 98 }}>
            <DynamicForm
              fields={selectinputconverter({
                value: postData.extratime.some(
                  (objExtraTime) =>
                    objExtraTime && objExtraTime.extratimetypeid == 1,
                )
                  ? 1
                  : 2,
                label: "",
                options: overtimeworkingdaysoptions,
              })}
              onChange={(id) =>
                id == 1 ? this.addExtraTime(1) : this.removeExtraTime(1)
              }
            />
          </div>
        </div>

        {postData.extratime.some(
          (objExtraTime) =>
            objExtraTime &&
            objExtraTime.extratimetypeid == 1 &&
            objExtraTime.overtimeconfig != null,
        ) &&
          this.renderOverTimeInput(
            postData.extratime.find(
              (objExtraTime) =>
                objExtraTime &&
                objExtraTime.extratimetypeid == 1 &&
                objExtraTime.overtimeconfig != null,
            ),
          )}

        <div
          className="display-flex"
          style={{
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: 16,
          }}
        >
          <div className="display-flex" style={{ alignItems: "center" }}>
            <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
            <p className="normal-dark">
              Pay when an employee does overtime on a non-work day (includes
              weeklyoff & mandatory holiday)
            </p>
          </div>
          <div style={{ width: 98 }}>
            <DynamicForm
              fields={selectinputconverter({
                value: postData.extratime.some(
                  (objExtraTime) =>
                    objExtraTime && objExtraTime.extratimetypeid == 2,
                )
                  ? 1
                  : 2,
                label: "",
                options: overtimeworkingdaysoptions,
              })}
              onChange={(id) =>
                id == 1 ? this.addExtraTime(2) : this.removeExtraTime(2)
              }
            />
          </div>
        </div>

        {postData.extratime.some(
          (objExtraTime) =>
            objExtraTime &&
            objExtraTime.extratimetypeid == 2 &&
            objExtraTime.overtimeconfig != null,
        ) &&
          this.renderOverTimeInput(
            postData.extratime.find(
              (objExtraTime) =>
                objExtraTime &&
                objExtraTime.extratimetypeid == 2 &&
                objExtraTime.overtimeconfig != null,
            ),
          )}

        <div
          className="display-flex margin-top-16"
          style={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            className="display-flex margin-bottom-16"
            style={{ alignItems: "center" }}
          >
            <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
            <p className="normal-dark">
              How do you want to calculate work hours?
            </p>
          </div>
          <div style={{ width: 216 }}>
            <DynamicForm
              fields={selectinputconverter({
                value: postData.isincludebreak ? 2 : 2,
                label: "",
                options: workhoursoptions,
              })}
              onChange={(id) =>
                this.updatePostData("isincludebreak", id == 1 ? true : false)
              }
            />
          </div>
        </div>

        <div
          className="display-flex"
          style={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            className="display-flex margin-bottom-16"
            style={{ alignItems: "center" }}
          >
            <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
            <p className="normal-dark">
              Do you want employees to work extra time only on approval?
            </p>
          </div>
          <div style={{ width: 330 }}>
            <DynamicForm
              fields={selectinputconverter({
                value: !postData.isetapprovalrequired
                  ? 3
                  : postData.ispastdateallowed
                  ? 2
                  : 1,
                label: "",
                options: approvaloptions,
              })}
              onChange={(e) => this.updatePostData("approvaltype", e)}
            />
          </div>
        </div>

        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div>
            <div className="floatleft" style={{ marginLeft: 304 }}>
              <Button
                className="btn btn-secondary-md-blue margin-right-16"
                variant="contained"
                onClick={this.onCancel}
              >
                Cancel
              </Button>
            </div>
            <div className="floatright" style={{ marginRight: 72 }}>
              <div>
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={() => this.onSave()}
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="clearfloat"></div>
          </div>
        </div>
        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={this.state.DialogOpen}
          onClose={() => this.setState({ DialogOpen: false })}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogContent>
            <div>
              <p className="normal-dark-secondary margin-bottom-8 t-bold">
                How many times do you want to duplicate?
              </p>
              <div style={{ width: 100 }}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: this.state.duplicateCount,
                    placeholder: "",
                    min: 1,
                    max: 1000,
                  })}
                  onChange={(e) => this.setState({ duplicateCount: e })}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ DialogOpen: false })}
              color="primary"
              className="btn btn-trans"
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary-md-blue"
              size="small"
              variant="contained"
              color="primary"
              onClick={this.duplicateBifuraction}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
